var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "col-12 px-0 d-flex align-items-stretch edito-tile-height" },
    [
      _c(
        "div",
        {
          staticClass: "container mw-100 border-gray mobile-tile bg-dark mb-0",
        },
        [
          _c("div", { staticClass: "col-12 px-0 bg-header-tile" }, [
            _c("div", { staticClass: "row" }, [
              _vm.showPicto5G
                ? _c("img", {
                    staticClass: "logo-5g-big",
                    attrs: { src: _vm.picto5gSrc, alt: "" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 pt-2 pb-1 ps-2 pe-3" }, [
                _c("h4", {
                  staticClass: "text-white pb-0 mb-0",
                  domProps: { innerHTML: _vm._s(_vm.titleHtml) },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 py-1 bg-dark text-white" }, [
                _c(
                  "ul",
                  { staticClass: "list" },
                  _vm._l(_vm.attributes, function (attributHtml) {
                    return _c("li", [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(attributHtml) },
                      }),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 py-1 ps-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "ob1-link-arrow ob1-link-reverse",
                    attrs: {
                      href: _vm.link,
                      "data-oevent-category": _vm.linkTms.category,
                      "data-oevent-action": _vm.linkTms.action,
                      "data-oevent-label": _vm.linkTms.label,
                    },
                  },
                  [_vm._v(_vm._s(_vm.linkLabel))]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }